import { buildUvInsertTextVisualiserSize } from "@shared/view/uv-inserts/build-text-visualiser-size"

/** Pure formatting helpers for dev visualiser props (no React). */

export function str(v: string | number | undefined): string | undefined {
  return v === undefined ? undefined : String(v)
}

export function buildTextSize(size: Record<string, string | number> | undefined) {
  return buildUvInsertTextVisualiserSize(size)
}
